import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1584955b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1584955b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2024/xushanB/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1584955b')) {
      api.createRecord('1584955b', component.options)
    } else {
      api.reload('1584955b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1584955b&scoped=true&", function () {
      api.rerender('1584955b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/member/memberSpecialDirect/index.vue"
export default component.exports